import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { ReviewVenuePage } from '#src/pages/ReviewPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/venue_/$venueId_/review')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { venueId } = params;
    await queryClient.ensureQueryData(venueQueryOptions({ venueId }));
  }
});

function RouteComponent() {
  const { venueId } = Route.useParams();

  const query = useSuspenseQuery(venueQueryOptions({ venueId }));
  const venue = query.data.data;

  return <ReviewVenuePage venue={venue} />;
}

function venueQueryOptions({ venueId }: { venueId: string }) {
  return getReactQueryOptions(publicApiQueryClient.venues.get, {
    params: { id: venueId }
  });
}
